import "./App.css";
import { Outlet, useNavigate } from "react-router-dom";
import axios from "axios";
import { useEffect } from "react";
import { NetworkCalls } from "./NetworkCalls";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

export default function App() {
  axios.defaults.baseURL = process.env.REACT_APP_BASE_URL;
  axios.defaults.withCredentials = true;

  let navigate = useNavigate();

  useEffect(() => {
      axios.interceptors.response.use(
          (response) => {
              if (response?.data) {
                  response.data = NetworkCalls.handleDates(response.data);
              }
              return response;
          },
          (error) => {
              const status = error?.response?.status;
              switch (status) {
                  case 401:
                      navigate("/login");
                      break;
                  case 500:
                      navigate("/ups");
                      break;
                  default:
                      break;
              }
              return Promise.reject(error);
          }
      );
  }, [navigate]);

  const queryClient = new QueryClient();

  return (
    <>
      <QueryClientProvider client={queryClient}>
        <div id="details">
          <Outlet />
        </div>
      </QueryClientProvider>
    </>
  );
}
